import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, ArrowRight } from 'lucide-react';
interface FinalCTAProps {
  onBrandClick?: () => void;
  onOrganizerClick?: () => void;
}
export function FinalCTA({
  onBrandClick,
  onOrganizerClick
}: FinalCTAProps) {
  const [showRoleSelection, setShowRoleSelection] = useState(false);
  return <section className="py-32 bg-slate-950 relative overflow-hidden" data-id="element-634">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-slate-800/40 via-slate-950 to-slate-950" data-id="element-635"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-636">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-6xl font-bold text-white mb-8 leading-tight" data-id="element-637">
          No more random sponsorships. <br data-id="element-638" />
          <span className="text-slate-500" data-id="element-639">Just better matches.</span>
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="flex flex-wrap justify-center gap-4 md:gap-8 mb-12 text-slate-300" data-id="element-640">
          {['Better relevance', 'Better experiences', 'Better results'].map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-641">
                <div className="bg-cyan-500/20 p-1 rounded-full" data-id="element-642">
                  <Check size={16} className="text-cyan-400" data-id="element-643" />
                </div>
                <span data-id="element-644">{item}</span>
              </div>)}
        </motion.div>

        <AnimatePresence mode="wait" data-id="element-645">
          {!showRoleSelection ? <motion.button key="main-cta" initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} exit={{
          opacity: 0,
          scale: 0.9
        }} onClick={() => setShowRoleSelection(true)} className="px-10 py-5 bg-cyan-500 hover:bg-cyan-400 text-slate-900 rounded-full font-bold text-xl shadow-[0_0_40px_rgba(6,182,212,0.3)] transition-all" data-id="element-646">
              Get Started with SponsrAI
            </motion.button> : <motion.div key="role-selection" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-647">
              <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} onClick={onBrandClick} className="px-8 py-5 bg-cyan-500 hover:bg-cyan-400 text-slate-900 rounded-full font-bold text-lg transition-all shadow-[0_0_30px_rgba(6,182,212,0.3)] flex items-center gap-2" data-id="element-648">
                I'm a Brand <ArrowRight size={20} data-id="element-649" />
              </motion.button>
              <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} onClick={onOrganizerClick} className="px-8 py-5 bg-purple-600 hover:bg-purple-500 text-white rounded-full font-bold text-lg transition-all shadow-[0_0_30px_rgba(168,85,247,0.3)] flex items-center gap-2" data-id="element-650">
                I'm an Organizer <ArrowRight size={20} data-id="element-651" />
              </motion.button>
            </motion.div>}
        </AnimatePresence>
      </div>
    </section>;
}